/*
 * Pochodzenie zamówienia (z jakiej reklamy/kampanii przyszedł odwiedzający) —
 * czysto pierwszostronne, bez żadnego skryptu, ciasteczka ani wywołania
 * sieciowego: tylko odczyt parametrów z adresu URL przy wejściu na stronę,
 * zapisany lokalnie, żeby przetrwał do momentu złożenia zamówienia (może
 * minąć kilka dni między kliknięciem w reklamę a zamówieniem). Widoczne
 * wyłącznie wewnętrznie, w panelu administratora — nigdy klientowi.
 *
 * Model "last touch": każda wizyta z parametrami reklamowymi w adresie
 * NADPISUJE poprzednio zapamiętane pochodzenie (to źródło realnie
 * doprowadziło do zamówienia). Wizyta bez takich parametrów (np. powrót
 * bezpośrednio na stronę) nic nie nadpisuje — pochodzenie z reklamy nie
 * ginie tylko dlatego, że ktoś potem wrócił z zakładki.
 */

const KEY = "prawly:attribution";
const FIELDS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "gclid", "gbraid", "wbraid", "ttclid", "fbclid"];

/* Identyfikatory kliknięć Google Ads są ważne ok. 90 dni (import konwersji
   offline odrzuca starsze) — dłużej niż to zapamiętane pochodzenie byłoby
   już tylko szumem, więc wygasa razem z nimi. gbraid/wbraid to odpowiedniki
   gclid dla ruchu z iOS (ograniczenia śledzenia) — bez nich kliknięcia z
   iPhone'ów lądowałyby w bazie jako zamówienia bez źródła. */
const MAX_AGE_MS = 90 * 24 * 3600 * 1000;

/* Domena zewnętrznego referrera (tylko domena, bez ścieżki i parametrów) i typ urządzenia — do raportów
   o źródle zamówień (np. wejścia z wyszukiwarek AI). */
function visitInfo() {
  const info = {};
  try {
    if (document.referrer) {
      const host = new URL(document.referrer).hostname.replace(/^www\./, "");
      if (host && host !== window.location.hostname.replace(/^www\./, "")) info.referrer_domain = host.slice(0, 80);
    }
  } catch {
    /* nieprawidłowy referrer */
  }
  try {
    info.device = window.matchMedia("(max-width: 759px)").matches ? "mobile" : window.matchMedia("(max-width: 1099px)").matches ? "tablet" : "desktop";
  } catch {
    /* stare przeglądarki */
  }
  return info;
}

export function captureAttribution() {
  try {
    const params = new URLSearchParams(window.location.search);
    const raw = {};
    for (const f of FIELDS) {
      const v = params.get(f);
      if (v) raw[f] = v.slice(0, 200);
    }
    if (!Object.keys(raw).length) {
      // Wejście bez parametrów reklamowych: poprzednio zapisane pochodzenie z reklamy zostaje (nie nadpisujemy go),
      // a gdy nic ważnego nie ma, zapisujemy samo wejście (strona, referrer, urządzenie) — bez parametrów reklamowych.
      if (getAttribution()) return;
      localStorage.setItem(
        KEY,
        JSON.stringify({ ...visitInfo(), landing_path: window.location.pathname.slice(0, 200), captured_at: new Date().toISOString() })
      );
      return;
    }
    Object.assign(raw, visitInfo());
    raw.landing_path = window.location.pathname.slice(0, 200);
    raw.captured_at = new Date().toISOString();
    localStorage.setItem(KEY, JSON.stringify(raw));
  } catch {
    /* prywatne okno / zablokowany storage — zamówienie i tak przejdzie, po prostu bez pochodzenia */
  }
}

/** Do dołączenia w ciele POST /cases przy składaniu zamówienia. */
export function getAttribution() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    const at = Date.parse(parsed?.captured_at);
    if (Number.isFinite(at) && Date.now() - at > MAX_AGE_MS) {
      localStorage.removeItem(KEY);
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}
